'use es6'; //#region Imports

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Map as ImmutableMap } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIStepIndicator from 'UIComponents/connectedStep/UIStepIndicator';
import { BOOKING_STEPS } from 'MeetingsLib/constants/steps'; //#endregion Imports

const stepKeys = ImmutableMap(BOOKING_STEPS);

const BookingStepIndicator = ({
  compact,
  currStep,
  embedded,
  isPreviewed = false,
  withPayment = false
}) => {
  const steps = (withPayment ? stepKeys : stepKeys.butLast()).valueSeq().toArray();
  const stepNames = steps.map(stepName => {
    const message = `stepIndicator.${stepName}`;
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: message
    }, message);
  });
  let stepIndex = steps.indexOf(currStep);

  if (stepIndex === -1) {
    stepIndex = steps.length;
  }

  if (compact || embedded || isPreviewed) return null;
  return /*#__PURE__*/_jsx(UIFlex, {
    justify: "center",
    style: {
      maxWidth: withPayment ? 940 : 540
    },
    className: "m-x-auto",
    children: /*#__PURE__*/_jsx(UIStepIndicator, {
      stepNames: stepNames,
      stepIndex: stepIndex,
      className: "m-top-8"
    })
  });
};

export default BookingStepIndicator;
BookingStepIndicator.propTypes = {
  compact: PropTypes.bool.isRequired,
  currStep: PropTypes.string,
  embedded: PropTypes.bool.isRequired,
  isPreviewed: PropTypes.bool,
  withPayment: PropTypes.bool
};